import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router, Event, NavigationEnd } from '@angular/router';
import { noWhitespaceValidator } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-new-my-teams',
  templateUrl: './new-my-teams.component.html',
  styleUrls: ['./new-my-teams.component.scss'],
})
export class NewMyTeamsComponent {
  @Output() saveMyTeamsEvent = new EventEmitter<{ payload: any; pathName: any }>();
  modalLabel: any;
  myTeamsData: any;
  myTeamsAddEditForm!: FormGroup;
  submitted = false;
  organizationlist: any;
  activatedRoute: any;
  selectOrganization: any;
  isHideDropDown!: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    public route: ActivatedRoute,
    private router: Router
  ) {
    this.activatedRoute = this.router.routerState.snapshot.url;
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.isHideDropDown = this.activatedRoute.includes('AdminForManageTeams') ? true : false;
    this.myTeamsData = this.modal?.modalService?.config?.initialState?.['myTeamsData'];
    this.organizationlist = this.myTeamsData?.organizationItems;
    this.organizatioListFunction();
  }

  ngOnInit(): void {
    this.myTeamsAddEditForm = this.formBuilder.group({
      teamName: [this.myTeamsData.name || '', [Validators.required, noWhitespaceValidator]],
      organizationName: [null, Validators.required],
    });
    this.setFormData();
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == this.myTeamsData.orgnizationId) {
        return (this.selectOrganization = item);
      }
    });
  }
  setFormData() {
    this.myTeamsAddEditForm.patchValue({ organizationName: this.selectOrganization });
  }
  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().startsWith(term.toLowerCase());
  }

  onClose() {
    this.modal.close();
  }

  onSave() {
    this.submitted = true;
    if (
      this.myTeamsAddEditForm.controls['organizationName'].value?.name == 'Organization' ||
      (this.activatedRoute == 'AdminForManageTeams' &&
        !this.myTeamsAddEditForm.controls['organizationName'].value?.name)
    ) {
      return;
    }
    if (this.myTeamsAddEditForm.controls['teamName'].valid) {
      const myTeamsAddEditPayload = {
        id: this.myTeamsData.id || 0,
        name: this.myTeamsAddEditForm.controls['teamName'].value.trimStart(),
        orgnizationId:
          this.myTeamsAddEditForm.controls['organizationName'].value?.id ||
          this.myTeamsData.orgnizationId,
      };
      this.saveMyTeamsEvent.emit({ payload: myTeamsAddEditPayload, pathName: this.activatedRoute });
    }
  }
}
